import { render, staticRenderFns } from "./LeaseList.vue?vue&type=template&id=0bf4c598"
import script from "./LeaseList.vue?vue&type=script&lang=ts"
export * from "./LeaseList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports